import React from 'react';
import './IntelligenceSecurity.css';
import { FaBrain, FaLock, FaMicrochip, FaMobile, FaUserShield } from 'react-icons/fa';

function IntelligenceSecurity() {
    return (
        <section className="intel-section-premium">
            <div className="intel-container-premium">
                <div className="intel-grid-premium">
                    <div className="intel-card-premium ai">
                        <div className="icon-box-premium"><FaBrain /></div>
                        <h3>AI-Powered Intelligence Layer</h3>
                        <ul className="intel-list-premium">
                            <li>AI Bank Reconciliation with OCR</li>
                            <li>Behavioral Analysis for customer patterns</li>
                            <li>Predictive Alerts for high-risk customers</li>
                            <li>Early Warning Systems for NPA</li>
                        </ul>
                    </div>

                    <div className="intel-card-premium security">
                        <div className="icon-box-premium"><FaUserShield /></div>
                        <h3>Security & Control Framework</h3>
                        <ul className="intel-list-premium">
                            <li>Biometric Security for approvals</li>
                            <li>Maker-Checker dual authorization system</li>
                            <li>Role-based access with audit trails</li>
                            <li>Head Office calendar & fund controls</li>
                            <li>Two step authentication with one time password</li>
                        </ul>
                    </div>
                    <div className="intel-card-premium security">
                        <div className="icon-box-premium"><FaMobile /></div>
                        <h3>Mobile & Digital Capabilities</h3>
                        <ul className="intel-list-premium">
                            <li>Mobile Loan Origination with online KYC creation</li>
                            <li>Digital loan and investment applications</li>
                            <li>WhatsApp integration for sales team communication</li>
                            <li>Quick customer creation with admin confirmation</li>
                        </ul>
                    </div>
                </div>

           <div className="additional-modules-premium modern-capabilities animated-capabilities">

    <h3 className="animated-capabilities-title">
        Specialized Capabilities
    </h3>

    <div className="animated-module-pills">
        <span>Arbitration & Legal Case Management</span>
        <span>CRM Engine with automated messaging</span>
        <span>Fund Balancer for future forecasting</span>
        <span>Inventory Management for gold loan operations</span>
        {/* <span>WhatsApp Integration</span> */}
        <span>Online Gold Loan services</span>
        <span>Automated event management for NPA buckets</span>
    </div>

</div>
            </div>
        </section>
        
    );
    
}

export default IntelligenceSecurity;
